import createCache from '@emotion/cache';

export function getDocumentNonce() {
	return typeof document === 'undefined'
		? undefined
		: document.querySelector('meta[property="csp-nonce"]')?.content;
}

export default function createEmotionCache(nonce) {
	return createCache({ key: 'css', nonce });
}
